import { useMemo, useCallback } from "react";
import classes from "./shipment.module.css";

import { CustomSelect } from "../../../../component/customSelect/CustomSelect";
import { shipmentDetailTableColumnsConfig } from "./shipmentDetailTableColumnsConfig";
import { Table } from "../../../../component/table/Table";
import { ShipmentStatusBadge } from "../OrderDetailPage";
import { StatusBadge } from "../../../../component/bulk/bulkSpares/bulkSparesDetail/BulkSpareDetailForm";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

export const Shipment = ({ shipment, onChange }) => {
  const columnDefs = useMemo(() => {
    if (!shipment?.category) return [];

    const hasVrp = shipment.category === "VRP";

    return shipmentDetailTableColumnsConfig.shipmentDetail(null, null, hasVrp);
  }, [shipment?.category]);

  const handleStatusSelect = useCallback(
    (statusId) => {
      if (!statusId || statusId === shipment.status_id) return;

      onChange({
        shipment_id: shipment.shipment_id,
        status: statusId,
      });
    },
    [shipment.shipment_id, shipment.status_id, onChange],
  );

  const validStatuses = shipment?.shipment_valid_status || [];
  const hasMultipleStatuses = validStatuses.length > 1;

  return (
    <div className={classes.box}>
      {/* HEADER */}
      <div className={classes.header}>
        <h2 className={classes.title}>{shipment?.title}</h2>

        <div className={classes.headerBadges}>
          <ShipmentStatusBadge status={shipment.status} />
          
        </div>
      </div>

      {/* ACTIONS */}
      <div className={classes.actions}>
        {hasMultipleStatuses && (
          <div className={classes.actions__wrapper}>
            <CustomSelect
              placeholder="Change Status"
              options={validStatuses}
              value={shipment.status_id} // ✅ direct backend control
              onChange={handleStatusSelect}
            />
          </div>
        )}

        <button className={classes.downloadBtn}>
          <ArrowDownTrayIcon className={classes.downloadBtn__icon} />
          <span>Download Invoice</span>
        </button>
      </div>

      <Table data={shipment?.items || []} columns={columnDefs} />
    </div>
  );
};
